import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs, InputNumber, Tooltip } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, PlusOutlined, CopyOutlined, SyncOutlined, DeleteOutlined, EditOutlined,ToolOutlined } from '@ant-design/icons';
import { ICard, listCards, createCard,updateEffectiveCard,updateCostPrice, updateCard, deleteCard, pageCards, createPunchRecord, transformCourse, transformNCourse } from '../../service/api/card';
import { listCourseDefinitions } from '../../service/api/courseDefinition';
import moment from 'moment';
import { FormInstance } from 'antd/lib/form/Form';
import umbrella from 'umbrella-storage';
import { ICardDefinition } from '../../service/api/cardDefinition';
import './css.less';
const { confirm } = Modal;
const { TabPane } = Tabs;
const { Option } = Select;

interface ICardListProps {
  studentId?: any
}
const CardList: React.FC<ICardListProps> = ({
  studentId,
}) => {
  const [cards, setCards] = useState<ICard[]>();
  const [cardDetail, setCardDetail] = useState<ICard>();
  const [cardVisible, setCardVisible] = useState(false);
  const [punchVisible, setPunchVisible] = useState(false);
  const [transformVisible, setTransformVisible] = useState(false);
  const [transformNVisible, setTransformNVisible] = useState(false);
  const [effectiveVisible, setEffectiveVisible] = useState(false);
  const [costPriceVisible, setCostPriceVisible] = useState(false);
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [courseDefinitions, setCourseDefinitions] = useState<ICardDefinition[]>();
  const formRef = React.createRef<FormInstance>();
  const transformFormRef = React.createRef<FormInstance>();
  const transformNFormRef = React.createRef<FormInstance>();
  const effectiveFormRef = React.createRef<FormInstance>();
  const costPriceFormRef = React.createRef<FormInstance>();
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: '名称',
      dataIndex: 'name',
      width: 200,
      key: 'name',
    },
    {
      title: '当前课程信息',
      dataIndex: 'courseMessage',
      width: 360,
      key: 'courseMessage'
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: 200,
      key: 'remark',
    },
    {
      title: '所属学员',
      dataIndex: 'studentName',
      width: 160,
      key: 'studentName',
    },
    {
      title: '购买时间',
      dataIndex: 'effectiveStartTime',
      width: 160,
      key: 'effectiveStartTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
      },
    },
    {
      title: '过期时间',
      dataIndex: 'effectiveEndTime',
      width: 160,
      key: 'effectiveEndTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD') : <>&mdash;</>
      },
    },
    {
      title: '有效时间（天）',
      dataIndex: 'effectiveDay',
      width: 160,
      key: 'effectiveDay',
    },
    {
      title: '花费价格',
      dataIndex: 'costPrice',
      width: 160,
      key: 'costPrice',
    },
    {
      title: '平均每节课价格',
      dataIndex: 'averageUnitPrice',
      width: 160,
      key: 'averageUnitPrice',
    },
    {
      title: '付款方式',
      dataIndex: 'payWayName',
      width: 160,
      key: 'payWayName',
    },
    {
      title: '是否赠送礼品',
      dataIndex: 'sendGifts',
      width: 160,
      key: 'sendGifts',
      render: (text: any, record: any) => {
        if (record.sendGifts) {
          return '是'
        } else {
          return '否'
        }
      }
    },
    {
      title: '合同是否签署',
      dataIndex: 'signContract',
      width: 160,
      key: 'signContract',
      render: (text: any, record: any) => {
        if (record.signContract) {
          return '是'
        } else {
          return '否'
        }
      }
    },
    {
      title: '操作',
      fixed: 'right' as 'right',
      width: 200,
      key: 'action',
      render: (text: any, record: any) => {
        return <Space size="middle">
          <Tooltip title="补录打卡记录">
          <CopyOutlined onClick={() => {
            setPunchVisible(true);
            setCardDetail(record);
          }} />
          </Tooltip>
          <Tooltip title="课程转换">
          <SyncOutlined onClick={() => {
            setTransformVisible(true);
            setCardDetail(record);
          }} />
          </Tooltip>
          <Tooltip title="修改过期时间">
          <EditOutlined onClick={() => {
            setEffectiveVisible(true);
            setCardDetail(record);
          }} />
          </Tooltip>
          <Tooltip title="负数课包订正转换">
          <ToolOutlined onClick={() => {
            setTransformNVisible(true);
            setCardDetail(record);
          }} />
          </Tooltip>
          
          {umbrella.getLocalStorage('username')=='陈士丹'?
           <>
           <Tooltip title="删除">
           <DeleteOutlined onClick={e => { onDelete(e, record) }} />
           </Tooltip>
           </>
           :<></>}

            <Tooltip title="修改花费价格">
           <EditOutlined onClick={() => {
             setCostPriceVisible(true);
             setCardDetail(record);
           }} />
           </Tooltip>
           
        </Space>
      },
    }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  useEffect(() => {
    if (cardDetail) {
      // 设置100毫秒的延迟 确保from组件已经加载完毕
      // setTimeout(() => {
      //   formRef.current!.setFieldsValue(cardDetail);
      // }, 100);
      // setTimeout(() => {
      //   transformFormRef.current!.setFieldsValue(cardDetail);
      // }, 100);
    }
  }, [cardDetail]);

  const loadData = () => {
    pageCards(pageNum, pageSize, studentId ? studentId : '').then((info: any) => {
      setCards(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
    listCourseDefinitions().then((info: any) => {
      setCourseDefinitions(info?.data);
    });
  }

  const onFinish = (values: any) => {
    console.log("values:" + values);
    if (cardDetail) {
      updateCard({
        ...values,
        id: cardDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("更新成功");
          onClose();
          loadData();
        }
      });
    } else {
      createCard(values).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info) {
          message.success("创建成功");
          onClose();
          loadData();
        }
      });
    }
  };

  const onDelete = (e: any, item: ICard) => {
    e.stopPropagation();
    confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确定要删除该购买记录吗？删除后无法恢复',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteCard(item.id).then((info: any) => {
          if (info) {
            console.log("info:" + JSON.stringify(info));
            message.success("删除成功");
            loadData();
          }
        });
      },
      onCancel() {
      },
    });
  }

  const onClose = () => {
    setCardDetail(undefined);
    setPunchVisible(false);
    if (formRef.current) {
      formRef.current!.resetFields();
    }
  }

  const onTransformClose = () => {
    setCardDetail(undefined);
    setTransformVisible(false);
    if (transformFormRef.current) {
      transformFormRef.current!.resetFields();
    }
  }

  const onTransformNClose = () => {
    setCardDetail(undefined);
    setTransformNVisible(false);
    if (transformNFormRef.current) {
      transformNFormRef.current!.resetFields();
    }
  }

  const onEffectiveClose = () => {
    setCardDetail(undefined);
    setEffectiveVisible(false);
    if (effectiveFormRef.current) {
      effectiveFormRef.current!.resetFields();
    }
  }

  const onCostPriceClose = () => {
    setCardDetail(undefined);
    setCostPriceVisible(false);
    if (costPriceFormRef.current) {
      costPriceFormRef.current!.resetFields();
    }
  }
  

  const onPageChange = (pageNum: number, pageSize?: number) => {
    console.log("pageNum:" + pageNum);
    console.log("pageSize:" + pageSize);
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  const punchRecord = (values: any) => {
    setLoading(true);
    if (cardDetail) {
      createPunchRecord({
        ...values,
        cardId: cardDetail.id
      }).then((info: any) => {
        console.log("info:" + JSON.stringify(info));
        if (info.success) {
        message.success("补录打卡记录成功");
        setPunchVisible(false);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  const onTransformCourse = (values: any) => {
    setLoading(true);
    if (cardDetail) {
      transformCourse({
        ...values,
        cardId: cardDetail.id
      }).then((info: any) => {
        if (info.success) {
        message.success("课程转换成功");
        setTransformVisible(false);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  const onTransformNCourse = (values: any) => {
    setLoading(true);
    if (cardDetail) {
      transformNCourse({
        ...values,
        fromCardId: cardDetail.id
      }).then((info: any) => {
        if (info.success) {
        message.success("课程转换成功");
        setTransformNVisible(false);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  const onEffectiveUpdate = (values: any) => {
    setLoading(true);
    if (cardDetail) {
      updateEffectiveCard({
        ...values,
        id: cardDetail.id
      }).then((info: any) => {
        if (info.success) {
        message.success("修改成功");
        setEffectiveVisible(false);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  const onCostPriceUpdate = (values: any) => {
    setLoading(true);
    if (cardDetail) {
      updateCostPrice({
        ...values,
        id: cardDetail.id
      }).then((info: any) => {
        if (info.success) {
        message.success("修改成功");
        setCostPriceVisible(false);
        setLoading(false);
        loadData();
        }
      });
    }
  };

  // 下拉框值
  const options = cardDetail?.cardCourses?.map((cardCourse) =>
    <Option key={cardCourse.courseDefinitionId} value={cardCourse.courseDefinitionId}>{cardCourse.name}</Option>);

    const courseDefinitionOptions = courseDefinitions?.map((courseDefinition) =>
    <Option key={courseDefinition.id} value={courseDefinition.id}>{courseDefinition.name}</Option>);

// 下拉框值
const cardOptions = cards?.map((card) =>
<Option key={card.id} value={card.id}>{card.name}</Option>);

// 【知识点】rowClassName 设置某一行的样式
  return (
    <Card bordered={false}>
      <Table dataSource={cards} columns={columns} pagination={false} scroll={{ x: 'true' }}
        rowClassName={(record, index) => {
          if (record.valid) {
            return 'valid';
          } else {
            return 'invalid';
          }
        }}
        />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
        <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
      <Drawer
        title={"补录打卡记录"}
        visible={punchVisible}
        width={720}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={punchRecord} ref={formRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="courseDefinitionId"
                label="课程"
                rules={[{ required: true, message: '请选择课程' }]}
              >
                <Select placeholder="请选择课程"  >
                  {options}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="punchTime"
                label="打卡时间"
                rules={[{ required: true, message: '请选择打卡时间' }]}
              >
                <DatePicker
                  format="YYYY-MM-DD HH:mm"
                  showTime
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="count"
                label="次数"
                rules={[{ required: true, message: '请填写补录次数' }]}
              >
                <InputNumber min={0.5} max={1000} step={0.5} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="remark"
                label="备注"
                rules={[{ required: false, message: '请输入备注' }]}
              >
                <Input placeholder="请输入备注" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
          <Col span={12}>
              <Form.Item
                name="needNotice"
                label="是否通知到公众号"
                rules={[{ required: true, message: '请填写是否通知到公众号' }]}
              >
                <Select >
                  <Option value="true">是</Option>
                  <Option value="false">否</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="noticeInfo"
                label="通知到公众号的内容"
                rules={[{ required: false, message: '请填写通知到公众号的内容' }]}
              >
                 <Input placeholder="请输入通知到公众号的内容" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
          <Col span={24}>
              <Form.Item
                name="needRecordCourseCostMoney"
                label="是否记录课消金额"
                rules={[{ required: true, message: '请填写是否记录课消金额' }]}
              >
                <Select >
                  <Option value="true">是</Option>
                  <Option value="false">否</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      <Drawer
        title={"课程转换"}
        visible={transformVisible}
        width={720}
        onClose={onTransformClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onTransformCourse} ref={transformFormRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="fromCourseDefinitionId"
                label="被转换的课程"
                rules={[{ required: true, message: '请选择被转换的课程' }]}
              >
                <Select placeholder="请选择被转换的课程"  >
                  {options}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="toCourseDefinitionId"
                label="转换成的课程"
                rules={[{ required: true, message: '请选择要转换成的课程' }]}
              >
                <Select placeholder="请选择要转换成的课程"  >
                  {courseDefinitionOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="value"
                label="转换数量"
                rules={[{ required: true, message: '请填写转换数量' }]}
              >
                {/* <InputNumber min={1} max={1000} /> */}
                 <InputNumber min={0.5} max={2000} step={0.5}/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onTransformClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title={"修改过期时间"}
        visible={effectiveVisible}
        width={720}
        onClose={onEffectiveClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onEffectiveUpdate} ref={effectiveFormRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="effectiveEndTime"
                label="过期时间"
                rules={[{ required: true, message: '请选择过期时间' }]}
              >
                 <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onEffectiveClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title={"修改花费价格"}
        visible={costPriceVisible}
        width={720}
        onClose={onCostPriceClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onCostPriceUpdate} ref={costPriceFormRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
          <Col span={12}>
              <Form.Item
                name="costPrice"
                label="花费价格"
                rules={[{ required: true, message: '请输入花费价格' }]}
              >
                <InputNumber style={{ width: "200px" }} placeholder="请输入花费价格" step="0.01"/>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onCostPriceClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>

      <Drawer
        title={"负数课包订正转换"}
        visible={transformNVisible}
        width={720}
        onClose={onTransformNClose}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose
      >
        <Form onFinish={onTransformNCourse} ref={transformNFormRef} layout="vertical" hideRequiredMark>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="toCardId"
                label="订正到的课包"
                rules={[{ required: true, message: '请选择要订正到的课包' }]}
              >
                <Select placeholder="请选择要订正到的课包"  >
                {cardOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>保存</Button>
                <Button htmlType="button" onClick={onTransformNClose}>取消</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Card>
  );
  // 【知识点】Button增加loading
};

export default CardList;
